var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-row"},[_c('vue-skeleton-loader',{attrs:{"type":"rec","width":1100,"height":446,"animation":"fade"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }